<div class="clr-row">
  <div class="clr-col-12">
    <div class="card">
      <div class="card-header">Производствени нареждания</div>
      <div class="card-block">
        <div class="card-text">
          <clr-tree>
            <clr-tree-node *clrRecursiveFor="
                let item of poListForView | keyvalue;
                getChildren: getChildrens" [clrExpanded]="true">
              <div style="margin-left: 10px; width:100%">
                <table class="table table-compact" *ngFor="let i of item.value.po?.po?.itemsWithIngredients">
                  <thead>
                    <tr>
                      <th colspan="3" [ngClass]="item.value.po?._found ? 'left no-change': 'left removed'">
                        {{item.value?.po?.po?.po?.DocumentType?.TypeName?.BG }} 
                        {{item.value?.po?.po?.poNumber || 'Няма ПН'}} 
                        {{item.value?.po?.po?.po?.DocumentDate | date}} 
                        <span *ngIf="item.value?.void" style="color:red">Трябва да се анулира</span>
                    </tr>
                    <tr>
                      <th [ngClass]="i?.item?._found ? 'left no-change': 'left added'">{{i?.item?.LineOrd}}</th>
                      <th class="left">{{i?.item?.Product?.Name?.BG}}</th>
                      <th [ngClass]="i?.item?._quantityChanged ? 'left changed' : 'left no-change'">{{i?.item?.ProducedQuantity?.Value}} {{i?.item?.ProducedQuantity?.Unit}}
                        <span *ngIf="i?.item?._quantityChanged && i?.item?._quantityChange?.fromQuantity" class="tooltip-content">
                          &nbsp;(от {{i?.item?._quantityChange?.fromQuantity}} {{i?.item?._quantityChange?.fromUnit}}
                          на  {{i?.item?._quantityChange?.toQuantity}} {{i?.item?._quantityChange?.toUnit}})
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let ing of i.ingredients">
                      <td [ngClass]="ing?._found ? 'left no-change': 'left added'">{{ing?.LineOrd}}</td>
                      <td class="left">{{ing?.Material?.Name?.BG}}</td>
                      <td [ngClass]="ing?._quantityChanged ? 'left changed' : 'left no-change'">{{ing?.UsedQuantity.Value}} {{ing?.UsedQuantity.Unit}}
                        
                        <span *ngIf="ing?._quantityChanged && ing?._quantityChange?.fromQuantity" class="tooltip-content">
                          &nbsp;(от {{ing?._quantityChange?.fromQuantity}} {{ing?._quantityChange?.fromUnit}}
                          на  {{ing?._quantityChange?.toQuantity}} {{ing?._quantityChange?.toUnit}})
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <hr>
            </clr-tree-node>
          </clr-tree>
        </div>
      </div>
    </div>
  </div>
</div>